import { openModal } from "action/modal/openModal";
import PAButton, { BUTTON_SIZE } from "component/design-system/buttons/PAButton";
import NextImage from "component/design-system/images/NextImage";
import { useTranslation } from "next-i18next";
import { useDispatch } from "react-redux";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import styles from "./videos.module.scss";

const videosCards = [
  {
    title: "The Ultimate Guide to Buying a Car.",
    url: "https://www.youtube.com/watch?v=pDa0v7KUO50&ab_channel=PartsAvatar",
    youtubeId: "pDa0v7KUO50",
    img: "/cms/pubicImages/images/How-NOT-to-buy-a-used-car.webp",
  },
  {
    title: "Scotty Kilmer Versus PartsAvatar.",
    url: "https://www.youtube.com/watch?v=zJD37bd3YCc&ab_channel=PartsAvatar",
    youtubeId: "zJD37bd3YCc",
    img: "/cms/pubicImages/images/VS-Scotty.webp",
  },
  {
    title: "How do LIQUI MOLY Additives work?",
    url: "https://www.youtube.com/watch?v=xG23O0eMr1c&ab_channel=PartsAvatar",
    youtubeId: "xG23O0eMr1c",
    img: "/cms/pubicImages/images/Liqui-Moly.webp",
  },

];

function PartsAvatarVideos() {
  const dispatch = useDispatch();
  const { t } = useTranslation("home");

  function handleOpenVideoModal(video: any, title: string) {
    dispatch(openModal("homepageVideoModal", {
      video,
      title,
    }));
  }
  return (
    <div className={`${styles.video_grid}`}>
      {videosCards.map((video: any, index: any) => (
        <div key={index + 1} className={`${styles.youtube_video}`}>

          <div className={`${styles.eachCard}`}>
            <div className={styles.thumbnail_wrapper}>
              <NextImage
                src={getRelativeImagePath(video.img)}
                alt={t(video.title)}
                fill
                className={styles.thumbnail}
              />
            </div>
            {" "}
            <i className={`fa fa-play ${styles.play_button}`} onClick={() => handleOpenVideoModal(video, video.title)}> </i>
          </div>
          <div className={styles.text_container}>
            <div className={`${styles.title}`}>{t(video.title)}</div>
            <PAButton
              size={BUTTON_SIZE.LARGE}
              onClick={() => handleOpenVideoModal(video, video.title)}
              className={styles.watch_now_button}
            >
              {t("Watch now")}
            </PAButton>
          </div>

        </div>
      ))}
    </div>
  );
}

export default PartsAvatarVideos;
